import { t } from '../../translate';
import { DominoBuilderError, DominoBuilderErrorScope, DominoBuilderErrorSeverity, DominoBuilderErrorType, } from '../../errors';
import { HandleType } from '../../types';
export function performInitialArgumentValueValidation(handle, value, parameter) {
    var _a;
    let errors = [];
    let validatedValue = value;
    let isRequired = (_a = parameter.required) !== null && _a !== void 0 ? _a : true;
    if (typeof validatedValue === 'boolean') {
        // handles case when value === false w/out typecasting
        return { errors, validatedValue };
    }
    else if (!validatedValue && isRequired) {
        if (!!parameter.defaultValue) {
            validatedValue = parameter.defaultValue;
            errors.push(new DominoBuilderError(DominoBuilderErrorType.MissingArgument, handle.type === HandleType.TriggerContextArgument
                ? DominoBuilderErrorScope.RUNTIME
                : DominoBuilderErrorScope.DESIGN, DominoBuilderErrorSeverity.INFO, t('errors.arguments.required_value_defaulted'), {
                path: `${handle.type}::${parameter.name}`,
                handle,
            }));
        }
        else {
            errors.push(new DominoBuilderError(DominoBuilderErrorType.MissingArgument, handle.type === HandleType.TriggerContextArgument
                ? DominoBuilderErrorScope.RUNTIME
                : DominoBuilderErrorScope.DESIGN, DominoBuilderErrorSeverity.ERROR, t('errors.arguments.field_required'), {
                path: `${handle.type}::${parameter.name}`,
                handle,
            }));
        }
    }
    else if (!validatedValue && !!parameter.defaultValue) {
        validatedValue = parameter.defaultValue;
    }
    return { errors, validatedValue };
}
//# sourceMappingURL=arguments.js.map